<div class="container">
  <h2>Institutional Accounts </h2>
  <ul>
    <li><a [routerLink]="['/introduction/iact/iact-list','byNumber']" title="Institutional Account List">Institutional Account List</a></li>
    <li>Chart of Accounts</li>
    <ul style="list-style:none;">
      <li *ngFor="let iacctRange of iacctRanges">
        <a [routerLink]="['/introduction/iact/iact-list', iacctRange.rangeId]"
          [title]="iacctRange.rangeName">{{iacctRange.rangeStart}}
          - {{iacctRange.rangeEnd}} <span class="iacct-item">{{iacctRange.rangeName}}</span></a>
      </li>
    </ul>
  </ul>
</div>